import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {IconButton, Toolbar, Typography, Tooltip} from "@material-ui/core";
import {AddBox, Refresh} from "@material-ui/icons";

const styles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
        backgroundColor: '#d8d8d8'
    },
    title: {
        flex: '0 0 auto'
    },
    actions: {
        color: theme.palette.text.secondary
    },
    spacer: {
        flex: '1 1 100%'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    }
});


const ExportsToolbar = (props) => {
    const {classes, title} = props;

    let onRefreshClick = props.handleRefreshButtonClick;
    if (!onRefreshClick) {
        onRefreshClick = () => {
            console.log("Clicked on refresh button");
        };
    }
    let onGenerateClick = props.handleGenerateButtonClick;
    if (!onGenerateClick) {
        onGenerateClick = () => {console.log("Clicked on generate button")};
    }

    return (
        <Toolbar className={classes.root}>
            <div className={classes.title}>
                <Typography color="inherit" variant="h6">
                    {title}
                </Typography>
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                <Tooltip title="Generate Export">
                    <IconButton aria-label="generate" onClick={onGenerateClick}>
                        <AddBox />
                    </IconButton>
                </Tooltip>
            </div>
            <div className={classes.actions}>
                <Tooltip title="Refresh List">
                    <IconButton aria-label="refresh" onClick={onRefreshClick}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </Toolbar>
    )
};

export default withStyles(styles)(ExportsToolbar);
